import CustomerInventoryPage from "./CustomerInventoryPage";
export default CustomerInventoryPage;
